if (!customElements.get("toggle-cross-sell")) {
  customElements.define(
    "toggle-cross-sell",

    class ToggleCrossSell extends HTMLElement {
      constructor() {
        super();

        this.main_product_form = document.querySelector('.product-form form[action="/cart/add"]') || document.querySelector('.product__page form[action="/cart/add"]') || document.querySelector('.product form[action="/cart/add"]') || document.querySelector('form[action="/cart/add.js"]') || document.querySelector('form[action="/cart/add"]');
        if (this.main_product_form === null) return console.error("ToggleCrossSell: No product form found");
      }

      connectedCallback() {
        this.addEventListener("click", this.onToggleProduct.bind(this));

        this.querySelectorAll(".toggle-cross-sell__product").forEach((product) => {
          if (product.querySelector(".toggle-cross-sell__variant-select") != null) {
            product.querySelector(".toggle-cross-sell__variant-select").addEventListener("change", this.variantChanged.bind(this, product));

            // On pré-sélectionne le iphone
            var iphoneType = localStorage.getItem("iphoneType");
            if (iphoneType != "" || iphoneType != null) {
              if (product.querySelector(".toggle-cross-sell__variant-select[data-is-iphone-selector]") != null) {
                product.querySelectorAll(".toggle-cross-sell__variant-select option").forEach((option) => {
                  if (iphoneType == option.textContent.trim()) {
                    product.querySelector(".toggle-cross-sell__variant-select").value = option.value;
                  }
                });
              }
            }
          }
        });

        // Fix pour le panier qui vient d'une appli et qui ne fonctionne pas si on ajoute des inputs dans le formulaire de base
        const originalButton = this.main_product_form.querySelector('.buy-buttons button[type="submit"]');
        const duplicatedButton = '<div id="duplicatedButton" class="button">' + originalButton.innerHTML + "</div>";
        originalButton.insertAdjacentHTML("afterend", duplicatedButton);
        originalButton.classList.add("hidden");
        this.main_product_form.querySelector("#duplicatedButton").addEventListener("click", this.handleProductFormSubmit.bind(this));
      }

      disconnectedCallback() {
        this.removeEventListener("click", this.onToggleProduct.bind(this));
        this.querySelectorAll(".toggle-cross-sell__product").forEach((product) => {
          if (product.querySelector(".toggle-cross-sell__variant-select") != null) {
            product.querySelector(".toggle-cross-sell__variant-select").removeEventListener("change", this.variantChanged.bind(this, product));
          }
        });
      }

      onToggleProduct(event) {
        const checkbox = event.target.querySelector('input[type="checkbox"]');
        if (checkbox) checkbox.checked = !checkbox.checked;
        //this.updateMainFormInputs();
      }

      variantChanged(product) {
        const select = product.querySelector(".toggle-cross-sell__variant-select");
        const optionSelected = select.options[select.selectedIndex];
        this.updateProductPrice(product, optionSelected);
        this.updateProductImage(product, optionSelected);
        this.updateVariantId(product, optionSelected);
        localStorage.setItem("iphoneType", optionSelected.textContent.trim());
      }

      updateProductPrice(product, optionSelected) {
        const variantPrice = optionSelected.dataset.price;
        product.querySelector(".toggle-cross-sell__product-price").innerHTML = variantPrice;

        if (optionSelected.dataset.compareAtPrice != null) {
          product.querySelector(".toggle-cross-sell__product-compare-at-price").innerHTML = optionSelected.dataset.compareAtPrice;
          product.querySelector(".toggle-cross-sell__product-badge-discount").innerHTML = optionSelected.dataset.discountPercentage;
          product.querySelector(".toggle-cross-sell__product-compare-at-price").style.display = "block";
          product.querySelector(".toggle-cross-sell__product-badge-discount").style.display = "flex";
        } else {
          product.querySelector(".toggle-cross-sell__product-compare-at-price").style.display = "none";
          product.querySelector(".toggle-cross-sell__product-badge-discount").style.display = "none";
        }
      }

      updateProductImage(product, optionSelected) {
        if (optionSelected.dataset.variantImage != null && product.querySelector(".toggle-cross-sell__product-image") != null) {
          const variantImage = optionSelected.dataset.variantImage;
          product.querySelector(".toggle-cross-sell__product-image img").src = variantImage;
        }
      }

      updateVariantId(product, optionSelected) {
        const variantId = optionSelected.value;
        product.querySelector(".toggle-cross-sell__product-checkbox").dataset.variantId = variantId;
        product.querySelector(".toggle-cross-sell__product-checkbox").checked = true;
        // this.updateMainFormInputs();
      }

      // resetMainFormInputs() {
      //   document.querySelectorAll(".from-toggle-cross-sell").forEach((input) => input.remove());
      // }

      // updateMainFormInputs() {
      //   this.resetMainFormInputs();

      //   this.querySelectorAll(".toggle-cross-sell__product").forEach((product, index) => {
      //     const checkbox = product.querySelector('input[type="checkbox"]');
      //     if (checkbox && checkbox.checked) {
      //       this.main_product_form.insertAdjacentHTML("beforeend", `<input type="hidden" class="from-toggle-cross-sell" name="items[${index + 1}][id]" value="${checkbox.dataset.variantId}">`);
      //     }
      //   });
      // }

      // Fix pour le panier qui vient d'une appli et qui ne fonctionne pas si on ajoute des inputs dans le formulaire de base
      handleProductFormSubmit() {
        let formData = {
          items: [],
        };

        // On ajoute le produit de base
        formData.items.push({
          id: this.main_product_form.querySelector('input[name="id"]').value,
          quantity: this.main_product_form.querySelector('input[name="quantity"]') ? this.main_product_form.querySelector('input[name="quantity"]').value : 1,
        });

        this.querySelectorAll(".toggle-cross-sell__product").forEach((product, index) => {
          const checkbox = product.querySelector('input[type="checkbox"]');
          if (checkbox && checkbox.checked) {
            formData.items.push({
              id: checkbox.dataset.variantId,
              quantity: 1,
            });
          }
        });

        if (formData.items.length === 0) return;

        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then(() => {
            window.monster_refresh();
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    }
  );
}
